import React from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import { BotaoComIcone } from 'vivace-fluent-motion';
import IntlMessage from "../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

const ImunologiaFiltroPage = (props) => {
  const intl = useIntl()
  return (
    <div>
      <Row className="kanban-filtro-container">
        <Col sm={'3'} style={{ marginLeft: '-10px' }}>
          <SelectComponent
            options={props.tecnicos}
            value={props.tecnicoSelecionado}
            onChange={(event) => props.onChangeTecnico(event)}
            placeholder={`${intl.formatMessage({ id: 'dashboards.cytology.selectTechnician' })}`}
            styles={{ borderColor: 'transparent' }}
            disabled={props.carregando}
          />
        </Col>
        <Col sm={'auto'}>
          <Input
            placeholder={`${intl.formatMessage({ id: 'dashboards.examDetail.numberOfExam' })}`}
            style={{ height: '45px', borderRadius: '5px', fontSize: '13px' }}
            onChange={props.onChangeNumeroExame}
            onKeyPress={props.onKeyPressNumeroExame}
            value={props.numeroDoExame}
            disabled={props.carregando}
            innerRef={props.numeroDoExameRef}
          />
        </Col>
        <Col sm={'auto'}>
          <Input
            placeholder={`${intl.formatMessage({ id: 'dashboards.examDetails.request' })}`}
            style={{ height: '45px', borderRadius: '5px', fontSize: '13px' }}
            onChange={props.onChangeNumeroPedido}
            onKeyPress={props.onKeyPressNumeroPedido}
            value={props.numeroDoPedido}
            disabled={props.carregando}
            //innerRef={props.numeroDoExameRef}
          />
        </Col>
        <Col className="w130">
          <Input
            placeholder={`${intl.formatMessage({ id: 'dashboards.examDetails.laud' })}`}
            style={{ height: '45px', borderRadius: '5px', fontSize: '13px' }}
            onChange={props.onChangeLaudo}
            onKeyPress={props.onKeyPressLaudo}
            value={props.laudoPesquisa}
            disabled={props.carregando}
          />
        </Col>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
          <div className="label-data"><IntlMessage id="period.name"/></div>
          <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
            <SelectComponent
              isClearable
              className="filtro-data"
              noOptionsMessage={`${intl.formatMessage({id: "dashboards.reports.noItemsFound"})}`}
              name="form-field-period"
              placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
              value={props.periodo}
              onChange={(e) => {
                props.onChangePeriodo(e);
                e && e.value ? props.mudarIntervaloPeriodo(e.value) : props.mudarIntervaloPeriodo('todos');
              }}
              options={props.periodos}
            />
          </div>

          {props.periodo && props.periodo.value === 'outro' && (
            <React.Fragment>
              <DebounceInput
                name="periodoDe"
                type="date"
                style={{width: '130px', display: 'block'}}
                className="filtro-data"
                value={props.periodoInicial}
                onChange={(value) => {props.onChangeData('periodoInicial', value.target.value)}}
                onKeyPress={(e) => props.onKeyPressData(e)}
              />
              <DebounceInput
                name="periodoAte"
                type="date"
                style={{width: '130px', display: 'block'}}
                className="filtro-data"
                value={props.periodoFinal}
                onChange={(value) => {props.onChangeData('periodoFinal', value.target.value)}}
                onKeyPress={(e) => props.onKeyPressData(e)}
              />
            </React.Fragment>
          )}
        </div>
        {props.onClickSearch && (
          <div className="col-auto">
            <Button
              className="btn btn-primary"
              onClick={props.onClickSearch}
              style={{ height: '38px', width: '38px' }}
              disabled={props.carregando}
            >
              <i className="icons-btn mv-basico-pesquisar"></i>
            </Button>
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto', height: '38px' }}>
          <BotaoComIcone
            className="btn btn-icon"
            color="secondary"
            icone="mv-basico-excluir_todos"
            style={{ marginLeft: 0 }}
            height={38}
            onClick={() => props.limparFiltro()}
          >
            <IntlMessage id="dashboards.general.clearFilters" />
          </BotaoComIcone>
          {props.onClickOrganize && (
            <BotaoComIcone
              className="btn btn-icon"
              color="secondary"
              onClick={props.onClickOrganize}
              style={{ marginLeft: 0 }}
              height={38}
              icone="mv-basico-datacenter"
            >
              <IntlMessage id="dashboards.cytology.organizeLots" />
            </BotaoComIcone>
          )}
           {props.onClickOrdem && (<BotaoComIcone
            className='btn btn-icon'
            color='secondary'
            onClick={props.onClickOrdem}
            style={{ marginLeft: 0 }}
            height={38}
            icone={props.sortAsc ? 'mv-basico-seta_cima' : 'mv-basico-seta_baixo'}
          >
            <IntlMessage id={props.sortAsc ? 'dashboards.general.ascendingOrder' : 'dashboards.general.descendingOrder'} />
          </BotaoComIcone>)}
        </div>
      </Row>
    </div>
  )
}

export default ImunologiaFiltroPage;



// WEBPACK FOOTER //
// ./src/pages/imunologia/content/imunologia.filtro.page.js